<template>
  <div class="product-list-container">
    <div class="header">
      <search-input v-model="SearchProduct" placeholder="Search for product" class="search-input" />
      <div @click="$router.push({name: 'reseller-add-route-product'})">
        <primary-button class="primary-button">Add Product</primary-button>
      </div>
    </div>
    <div class="table table-header">
      <div class="first"></div>
      <div class="second">Product Name</div>
      <div class="third">Created On</div>
      <div class="fourth">Created By</div>
      <div class="fifth">Used By</div>
      <div class="six">State</div>
      <div class="seven"></div>
    </div>
    <div class="table-body-wrapper">
      <div
        v-for="product in products"
        :key="product.productId"
        class="table table-body table-body-deactivated"
      >
        <div class="first">
          <div class="circle"></div>
        </div>
        <div class="second">{{ product.productName }}</div>
        <div class="third">{{ product.createdOn }}</div>
        <div class="fourth">
          <img class="avatar" src="@/assets/ben-unsplash.jpg" alt />
          {{ product.createdBy }}
        </div>
        <div class="fifth">
          <img class="avatar" src="@/assets/company-logo.png" alt />
          {{ product.ownedBy }}
        </div>
        <div class="six">{{product.state}}</div>
        <div class="seven">
          <svg
            @click="$router.push({name: 'reseller-edit-route-product', params: {id: product.productId}})"
            class="svg-grey"
            width="30px"
            height="30px"
            viewBox="0 0 30 30"
            version="1.1"
          >
            <path
              d="M21.0636684,5 L16.5223005,5 C16.0222902,5 15.6155648,5.41380074 15.6155648,5.92250923 L15.6155648,19.7548339 C15.6155648,20.0601476 15.7303938,20.4698893 15.8885285,20.7291513 L18.1395544,24.4204428 C18.2910881,24.6688561 18.5293057,24.8114391 18.793057,24.8114391 C19.0568083,24.8114391 19.2949534,24.6688561 19.4465596,24.420369 L21.6974404,20.7292251 C21.8556477,20.4698155 21.9704767,20.0601476 21.9704767,19.7548339 L21.9704767,5.92250923 C21.9704041,5.41380074 21.5636062,5 21.0636684,5 Z M19.1930363,22.7361624 L18.3929326,22.7361624 L17.1373575,20.6773432 L20.4485389,20.6773432 L19.1930363,22.7361624 Z M16.7035751,19.5703321 L16.7035751,8.61188192 L18.2488705,8.61188192 L18.2488705,19.5703321 L16.7035751,19.5703321 Z M19.3370259,19.5703321 L19.3370259,8.61188192 L20.8823212,8.61188192 L20.8823212,19.5703321 L19.3370259,19.5703321 Z M20.8823212,6.10701107 L20.8823212,7.50487085 L16.7036477,7.50487085 L16.7036477,6.10701107 L20.8823212,6.10701107 Z M16.4717409,23.8886347 C16.7721969,23.8886347 17.0157824,24.1364576 17.0157824,24.4421402 C17.0157824,24.7478229 16.7721969,24.9956458 16.4717409,24.9956458 L8.56943005,24.9956458 C8.26897409,24.9956458 8.0253886,24.7478229 8.0253886,24.4421402 C8.0253886,24.1363838 8.26897409,23.8886347 8.56943005,23.8886347 L16.4717409,23.8886347 Z"
              id="path-1"
            />
          </svg>
          <svg
            @click="deleteProduct(product.productId)"
            class="svg-grey"
            width="30px"
            height="30px"
            viewBox="0 0 30 30"
            version="1.1"
          >
            <path
              d="M22.0359259,7.63839416 L18.7919259,7.63839416 L18.7919259,6.35036496 C18.7919259,5.60576642 18.1771852,5 17.4215556,5 L12.5477037,5 C11.7920741,5 11.1773333,5.60576642 11.1773333,6.35036496 L11.1773333,7.63839416 L7.93333333,7.63839416 C7.42274074,7.63839416 7.00740741,8.04766423 7.00740741,8.55080292 L7.00740741,10.2229927 C7.00740741,10.7261314 7.42274074,11.1354015 7.93333333,11.1354015 L8.47111111,11.1354015 L8.47111111,23.6922628 C8.47111111,24.3966423 9.05266667,24.969635 9.76740741,24.969635 L20.2017778,24.969635 C20.9165185,24.969635 21.4980741,24.3966423 21.4980741,23.6922628 L21.4980741,11.1354745 L22.0359259,11.1354745 C22.5465185,11.1354745 22.9618519,10.7262044 22.9618519,10.2230657 L22.9618519,8.55080292 C22.9618519,8.04773723 22.5464444,7.63839416 22.0359259,7.63839416 Z M12.2884444,6.35036496 C12.2884444,6.21189781 12.4071852,6.09489051 12.5477037,6.09489051 L17.4215556,6.09489051 C17.5620741,6.09489051 17.6808148,6.21189781 17.6808148,6.35036496 L17.6808148,7.63839416 L12.2884444,7.63839416 L12.2884444,6.35036496 Z M20.386963,23.6923358 C20.386963,23.7912409 20.3021481,23.8748175 20.2017778,23.8748175 L9.76740741,23.8748175 C9.66703704,23.8748175 9.58222222,23.7912409 9.58222222,23.6923358 L9.58222222,11.1354745 L20.386963,11.1354745 L20.386963,23.6923358 Z M21.8507407,10.0405839 L8.11851852,10.0405839 L8.11851852,8.73328467 L21.8507407,8.73328467 L21.8507407,10.0405839 Z M11.7328889,22.3270073 C11.426,22.3270073 11.1773333,22.0818978 11.1773333,21.779562 L11.1773333,13.4284672 C11.1773333,13.1261314 11.426,12.8810219 11.7328889,12.8810219 C12.0397037,12.8810219 12.2884444,13.1261314 12.2884444,13.4284672 L12.2884444,21.779562 C12.2884444,22.0818978 12.0397037,22.3270073 11.7328889,22.3270073 Z M14.9846667,22.3270073 C14.6778519,22.3270073 14.4291111,22.0818978 14.4291111,21.779562 L14.4291111,13.4284672 C14.4291111,13.1261314 14.6777778,12.8810219 14.9846667,12.8810219 C15.2915556,12.8810219 15.5402222,13.1261314 15.5402222,13.4284672 L15.5402222,21.779562 C15.5402222,22.0818978 15.2915556,22.3270073 14.9846667,22.3270073 Z M18.2363704,22.3270073 C17.9294815,22.3270073 17.6808148,22.0818978 17.6808148,21.779562 L17.6808148,13.4284672 C17.6808148,13.1261314 17.9294815,12.8810219 18.2363704,12.8810219 C18.5432593,12.8810219 18.7919259,13.1261314 18.7919259,13.4284672 L18.7919259,21.779562 C18.7919259,22.0818978 18.5432593,22.3270073 18.2363704,22.3270073 Z"
              id="path-1"
            />
          </svg>
        </div>
      </div>
    </div>
    <div class="buttons-wrapper">
      <pagination-component
        @change-page="changePage($event)"
        :page="Page"
        :per-page="per_page"
        :total="totalPage"
        :qnt="products.length"
      />
    </div>
  </div>
</template>

<script>
import { format } from "date-fns";
import { mapGetters, mapActions } from "vuex";

export default {
  components: {
    SearchInput: () => import("@/components/Inputs/SearchInput.vue"),
    PrimaryButton: () => import("@/components/Buttons/PrimaryButton.vue"),
    SecondaryButton: () => import("@/components/Buttons/SecondaryButton.vue"),
    PaginationComponent: () => import("@/components/Pagination.vue")
  },
  computed: {
    ...mapGetters({
      getProducts: "products/getProducts",
      totalPage: "products/getTotalPages"
    }),
    products() {
      return this.getProducts.map(product => ({
        productName: product.product_name,
        createdOn: format(product.created_on, "D MMM YYYY"),
        createdBy: product.created_by,
        ownedBy: product.compani_name,
        productId: product.product_uuid,
        routingId: product.routing_uuid,
        state: product.public === true ? "public" : "private"
      }));
    }
  },
  data: () => ({
    SearchProduct: "",
    Page: 0,
    dialog: null,
    vendors: []
  }),
  created() {
    this.getAllProducts();
  },
  watch: {
    SearchProduct: function() {
      this.Page = 0;
      this.getAllProducts();
    }
  },
  methods: {
    ...mapActions({
      viewAllProducts: "products/getProductList"
    }),
    changePage(page) {
      this.Page = page;
      this.getAllProducts();
    },
    getAllProducts() {
      this.viewAllProducts({
        page: this.Page,
        product_name: this.SearchProduct
      });
    },
    GetVendorList(search, page) {
      this.$store
        .dispatch("GetVendorList", {
          search: search,
          page: page,
          paid: ""
        })
        .then(res => {
          console.log("res--->", res);
          this.vendors = res.items.map(this.transformVendors);
          // this.PerPage = res.per_page;
          // this.Total = res.total;
          // this.TotalPages = res.total / res.per_page;
        });
    },
    transformVendors(i, k) {
      return {
        contactName: i.vendor_name,
        vendorName: i.vendor_name,
        salesEmail: i.sales_email,
        rateEmail: i.rate_email,
        nocEmail: i.noc_email,
        vendorId: i.vendor_uuid,
        type: i.vendor_type,
        contactPerson: i.contact_person,
        logo_file: i.logo_file_uuid
      };
    },
    deleteProduct(productId) {
      this.$swal({
        title: "Are you sure?",
        text: "You will not be able to recover this company!",
        type: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, delete it!",
        cancelButtonText: "No, keep it"
      }).then(result => {
        if (result.value) {
          this.$store
            .dispatch("deleteProduct", productId)
            .then(res => {
              console.log("res--->", res);
              this.getAllProducts();
              this.$swal(
                "Deleted!",
                "Your product has been deleted.",
                "success"
              );
            })
            .catch(err => {
              this.$snotify.error(err.response.statusText);
            });
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.product-list-container {
  .buttons-wrapper {
    display: flex;
    align-items: center;
    width: fit-content;
  }
  .header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 40px;
    margin-bottom: 20px;
    .search-input {
      max-width: 345px;
      height: 100%;
      background-color: #ffffff;
    }
    .primary-button {
      height: 40px;
      width: 130px;
    }
  }
  .table {
    display: flex;
    height: 44px;
    align-items: center;
    width: 100%;
    padding-right: 20px;
    box-sizing: border-box;
    margin-bottom: 0;
    .first {
      min-width: fit-content;
      width: 3%;
      min-width: 30px;
      display: flex;
      justify-content: center;
      align-items: center;
      .circle {
        height: 10px;
        width: 10px;
        border-radius: 50%;
        background-color: #24e2b8;
      }
    }
    .second {
      width: 18.5%;
      min-width: fit-content;
    }
    .third {
      width: 18.5%;
      min-width: fit-content;
    }
    .fourth {
      width: 25%;
      min-width: fit-content;
      .avatar {
        height: 30px;
        width: 30px;
        border-radius: 40px;
        vertical-align: middle;
        object-fit: cover;
        margin-right: 8px;
      }
    }
    .fifth {
      min-width: fit-content;
      width: 15.5%;
      .avatar {
        height: 30px;
        width: 30px;
        border-radius: 40px;
        vertical-align: middle;
        object-fit: cover;
        margin-right: 8px;
      }
    }
    .six {
      min-width: fit-content;
      width: 11%;
    }
    .seven {
      min-width: fit-content;
      width: 17.5%;
      display: flex;
      align-items: center;
      justify-content: flex-end;
      .svg-grey {
        fill: #55616e;
        margin-left: 20px;
      }
    }
  }
  .table-header {
    height: 37px;
    color: #212b36;
    font-family: "Helvetica Neue";
    font-size: 14px;
    font-weight: 600;
    line-height: 16px;
  }
  .table-body-wrapper {
    margin-bottom: 10px;
    border-radius: 4px 4px 0 0;
    width: 100%;
    height: fit-content;
    box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
    background-color: #ffffff;
    .table-body {
      color: #212b36;
      font-family: "Helvetica Neue";
      font-size: 14px;
      line-height: 20px;
      box-shadow: inset 0 -1px 0 0 #f0f1fa;
    }
    .table-body-deactivated {
      background-color: #ffffff; //#f0f1fa;
      .first {
        .circle {
          background-color: #d2305b;
        }
      }
    }
    .fifth {
      color: #007bff;
      text-decoration: underline;
      cursor: pointer;
    }
  }
}
</style>

